import React from 'react';
import { FieldGroupService } from '../../../services/FieldGroups';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import DropdownSelector from '../../dropdowns/DropdownSelector';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

/**
 * 現場に設定されたグループの複数選択 ドロップダウン
 * @param selectedValues {array} 初期値
 * @param onSelect {func} 選択処理時のcallback処理
 */
export const FieldGroupsDropdown = ({
  selectedValues,
  onSelect,
  clearFlag,
}) => (
  <DropdownSelector
    className='form-element__element'
    label='未選択'
    multiple={true}
    selectorName='field_group_id'
    api={params =>
      // 検索専用のグループ一覧
      FieldGroupService.listForSearch(SessionStorageService.getFieldId(), params)
    }
    apiParams={{
      limit: REQUEST_PARAMS.parentLimit,
    }}
    apiSearchKey='name'
    selectedValues={selectedValues}
    keyName='name'
    valueName='id'
    apiBindDataKey={'field_groups'}
    onSelect={onSelect}
    clearFlag={clearFlag}
  />
);



// WEBPACK FOOTER //
// ./src/components/dropdowns/multi/FieldGroups.jsx